import styled from "styled-components";

export const NavWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  position: fixed;
  top: 0;
  background: white;
  left: 0;
  right: 0;
  z-index: 5;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
`;

export const NavBar = styled.div`
  display: flex;
  padding: 0 15px;
  @media screen and (max-width: 600px) {
    display: none;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

export const SpaceApart = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const HeaderText = styled.span`
  font-size: 1.15rem;
  letter-spacing: 1.6px;
  color: inherit;
  padding-right: 10px;
  border-right: 1px solid lightgrey;
  @media screen and (max-width: 600px) {
    border-right: unset;
    margin-right: -15px;
    margin-left: -15px;
    padding: 0 15px;
    font-size: 16px;
    max-width: 250px;
  }
`;

export const HeaderContent = styled.div`
  display: block;
  .mobile-menu {
    display: none;
  }
  @media screen and (max-width: 600px) {
    justify-content: space-between;
    flex-grow: 1;
    margin-right: -15px;
    margin-left: -15px;
    padding: 10px 20px;
    border-top: 1px solid #e8e8e8;
    background-color: #0c233f;
    color: white;
    a {
      color: white;
    }
    & :not(:first-child) {
      display: none;
    }
    & .mobile-menu {
      float: right;
      display: block;
    }
  }
`;

export const MainHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  padding: 10px 0px;
  img {
    height: 24px;
  }
  @media (max-width: 420px) {
    justify-content: center;
    img {
      height: 30px;
    }
    padding: unset;
  }
`;



// WEBPACK FOOTER //
// ./src/components/header/Header.styles.js